import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, StatusBadge, Loading, Tag } from "@/components/common";
import { Scissors, Play, Info, Translate } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Shorts() {
  const { data: shorts, loading } = useFetch("/shorts");
  if (loading || !shorts) return <Loading />;

  return (
    <div>
      <PageHeader icon={Scissors} title="AI Shorts Factory"
        subtitle="After an episode is completed, Studio AI analyses it for strong Shorts moments — with reframing to vertical 9:16, captions and per-language output." />

      <div className="mb-6 flex items-start gap-3 rounded-xl border border-white/8 bg-black/20 px-4 py-3">
        <Info size={18} weight="duotone" className="text-[#00E5FF] mt-0.5" />
        <p className="text-sm text-zinc-400">Scores explain observable factors and our own historical analytics — never a guarantee something will go viral.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {shorts.map((s, i) => (
          <Panel key={s.id} data-testid={`short-${s.id}`} className="p-0 overflow-hidden panel-hover">
            <div className="relative aspect-[9/16] max-h-72">
              <img src={s.image} alt="" className="h-full w-full object-cover" />
              <div className="absolute inset-0 scrim" />
              <span className="absolute top-2 left-2 font-mono text-xs bg-black/60 rounded px-2 py-0.5">SHORT #{i + 1}</span>
              <div className="absolute top-2 right-2 flex flex-col items-end gap-1">
                <div className="rounded-full bg-black/60 px-2 py-0.5 text-[11px] text-white">Score {s.score}</div>
              </div>
              <button onClick={() => toast("Phase 2: preview the vertical short.")} className="absolute inset-0 flex items-center justify-center">
                <div className="h-12 w-12 rounded-full glass flex items-center justify-center"><Play size={20} weight="fill" className="text-white" /></div>
              </button>
              <div className="absolute bottom-2 left-2 right-2">
                <StatusBadge status={s.status} />
                <p className="mt-1 text-sm font-semibold text-white">"{s.hook}"</p>
                <p className="text-[11px] text-zinc-300">{s.clip} · {s.duration}</p>
              </div>
            </div>
            <div className="p-4">
              <p className="text-xs text-zinc-400">{s.reason}</p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {s.languages?.map((l) => <span key={l} className="inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-[10px] text-zinc-300"><Translate size={10} />{l}</span>)}
              </div>
              <div className="mt-2 flex flex-wrap gap-1.5">{s.platforms?.map((p) => <Tag key={p} className="text-[10px]">{p}</Tag>)}</div>
            </div>
          </Panel>
        ))}
      </div>
    </div>
  );
}
